import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import LoginCas from './pages/Login/loginCas'
import Layout from './pages/Layout'
import SaasLayout from './pages/SaasLayout'
import PrivateRoute from './components/PrivateRoute'
import history from './utils/history'
import Login from './pages/Login'
import Help from './pages/Help'
import SaasLogin from './pages/SaasLogin'
import WXLogin from './pages/WXLogin'
import WXHtml from './pages/WXHtml'
import ApplMemberPage from './pages/SaasLayout/ApplMemberPage'
import BindWxPage from './pages/SaasLayout/BindWxPage'
import Loadingpage from './pages/LoadingPage'
import AiSaasLogin from './pages/AiSaasLogin'
import McpLogin from './pages/McpLogin'
import LinkPage from './pages/LinkPage'

const PrivacyAgreement = lazy(() => import('./pages/PrivacyAgreement'))
const ContactInformation = lazy(() => import('./pages/ContactInformation'))
const ServiceAgreement = lazy(() => import('./pages/ServiceAgreement'))

const WDPrivacyAgreement = lazy(() => import('./pages/WDAgreement/PrivacyAgreement.js'))
const WDServiceAgreement = lazy(() => import('./pages/WDAgreement/ServiceAgreement.js'))

export default function App() {
  return (
    <BrowserRouter history={history} basename={process.env.PUBLIC_URL  || undefined}>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Redirect exact from="/" to="/home"></Redirect>
          <Route path="/loginHtml">{<Login></Login>}</Route>
          <Route path="/help/:id">{<Help></Help>}</Route>
          <Redirect exact from="/help" to="/help/10002.md"></Redirect>

          <Route path="/legal-agreement/tos.html">{<ServiceAgreement />}</Route>
          <Route path="/legal-agreement/privacy.html">
            {<PrivacyAgreement />}
          </Route>
          <Route path="/legal-agreement/about.html">
            {<ContactInformation />}
          </Route>

          <Route path="/legal-agreement/wd_tos.html">{<WDServiceAgreement />}</Route>
          <Route path="/legal-agreement/wd_privacy.html">
            {<WDPrivacyAgreement />}
          </Route>
          
          <Route path="/saas/invite">{<ApplMemberPage />}</Route>
          <Route exact path="/bindwxpage/:scan_id">{<BindWxPage />}</Route>
          <Route path="/login">{<LoginCas />}</Route>
          <Route path="/saasLogin">{<SaasLogin />}</Route>
          <Route path="/aiSaasLogin">{<AiSaasLogin />}</Route>
          <Route path="/mcpLogin" render={({ location }) => <McpLogin key={location.pathname + location.search} />} />
          <Route path="/loading">{<Loadingpage />}</Route>
          <Route path="/link">{<LinkPage />}</Route>
          <Route exact path="/wxLogin/:scan_id">{<WXLogin />}</Route>
          <Route exact path="/wxHtml">{<WXHtml />}</Route>
          <PrivateRoute path="/home">{<Layout />}</PrivateRoute>
          <PrivateRoute path="/saas/noProject">{<Layout />}</PrivateRoute>
          <PrivateRoute path="/saas/guidePage">{<Layout />}</PrivateRoute>
          <PrivateRoute path="/saas">{<SaasLayout />}</PrivateRoute>
          <Redirect path="*" to="/home"></Redirect>
        </Switch>
      </Suspense>
    </BrowserRouter>
  )
}
